import { useInView } from "@/hooks/reveal-in-view";
import Image from "next/image";
import React, { FC, useRef } from "react";
import SplitTextAnimation from "../split-text-animation";
import { loadJotForm } from "../../util/client/jotform";

interface Props {
  title: string;
}

const FORM_FIELDS = [
  null,
  { name: "heading", qid: "1", text: "Form", type: "control_head" },
  { name: "submit2", qid: "2", text: "Submit", type: "control_button" },
  {
    description: "",
    name: "email",
    qid: "3",
    subLabel: "example@example.com",
    text: "Email",
    type: "control_email",
  },
];

export const ResourcesCta: FC<Props> = ({ title }) => {
  const [email, setEmail] = React.useState("");

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  // The JotForm stack (~500 KB of JS) is only fetched once the form scrolls
  // near the viewport. The form itself is a plain POST and works without it.
  React.useEffect(() => {
    if (!isInView) return;
    loadJotForm().then((JotForm) => {
      if (!JotForm) return;
      JotForm.newDefaultTheme = true;
      JotForm.extendsNewTheme = false;
      JotForm.singleProduct = false;
      JotForm.newPaymentUIForNewCreatedForms = true;
      JotForm.newPaymentUI = true;
      JotForm.clearFieldOnHide = "disable";
      JotForm.submitError = "jumpToFirstError";
      JotForm.showJotFormPowered = "new_footer";
      JotForm.poweredByText = "Powered by Jotform";
      JotForm.isNewSACL = true;
      JotForm.init(function () {
        JotForm.alterTexts(undefined);
      });
      JotForm.prepareCalculationsOnTheFly(FORM_FIELDS);
      setTimeout(function () {
        JotForm.paymentExtrasOnTheFly(FORM_FIELDS);
      }, 20);
    });
  }, [isInView]);

  return (
    <div className="resourcesCta" ref={ref}>
      <div
        className="resourcesCta--inner"
        style={{
          transform: isInView ? "none" : `translateY(20px)`,
          opacity: isInView ? 1 : 0,
          transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
        }}
      >
        <SplitTextAnimation
          htmlElement={<h2 className="resourcesCta--title">{title}</h2>}
          isInView={isInView}
        />
        <form
          className="jotform-form resourcesCta--form"
          action="https://eu-submit.jotform.com/submit/231793919456066"
          method="post"
          name="form_231793919456066"
          id="231793919456066"
          acceptCharset="utf-8"
          autoComplete="on"
          target="_blank"
          style={{
            transform: isInView ? "none" : `translateY(20px)`,
            opacity: isInView ? 1 : 0,
            transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
          }}
        >
          <input type="hidden" name="formID" value="231793919456066" readOnly />
          <input type="hidden" id="JWTContainer" value="" readOnly />
          <input type="hidden" id="cardinalOrderNumber" value="" readOnly />
          <div role="main" className="form-all">
            <ul className="form-section page-section">
              <li
                className="form-line"
                data-type="control_email"
                id="id_3"
                style={{
                  transform: isInView ? "none" : `translateY(20px)`,
                  opacity: isInView ? 1 : 0,
                  transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                }}
              >
                <label
                  className="form-label form-label-top form-label-auto"
                  id="label_3"
                  htmlFor="input_3"
                >
                  Email
                </label>
                <div id="cid_3" className="form-input-wide" data-layout="half">
                  <span
                    className="form-sub-label-container"
                    style={{
                      verticalAlign: "top",
                    }}
                  >
                    <input
                      type="email"
                      id="input_3"
                      name="q3_email"
                      className="form-textbox validate[Email]"
                      data-defaultvalue=""
                      size={310}
                      value={email}
                      data-component="email"
                      aria-labelledby="label_3 sublabel_input_3"
                      onChange={(event) => {
                        setEmail(event.target.value);
                      }}
                    />
                  </span>
                </div>
              </li>
              <li
                className="form-line"
                data-type="control_button"
                id="id_2"
                style={{
                  transform: isInView ? "none" : `translateY(20px)`,
                  opacity: isInView ? 1 : 0,
                  transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                }}
              >
                <div id="cid_2" className="form-input-wide" data-layout="full">
                  <div
                    data-align="auto"
                    className="form-buttons-wrapper form-buttons-auto jsTest-button-wrapperField"
                  >
                    <button
                      id="input_2"
                      type="submit"
                      className="link link_white link_full resourcesCta--submit"
                      data-component="button"
                      data-content=""
                      data-title="Submit"
                    >
                      <span>Submit</span>
                    </button>
                  </div>
                </div>
              </li>
              <li
                style={{
                  display: "none",
                }}
              >
                Should be Empty:{" "}
                <input type="text" name="website" value="" readOnly />
              </li>
            </ul>
          </div>
          <input
            type="hidden"
            className="simple_spc"
            id="simple_spc"
            name="simple_spc"
            value="231793919456066-231793919456066"
            readOnly
          />
        </form>
      </div>
      <Image
        src="/images/spiral-2.webp"
        alt="Spiral"
        width={1600}
        height={1823}
        role="presentation"
        draggable={false}
        className="resourcesCta--spiral"
        style={{
          opacity: isInView ? 1 : 0,
        }}
      />
    </div>
  );
};
